function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import BasicHeaderComponent from "segments/desktop/header/layouts/components/basic-header/basic-header-component";
import HeaderMenuComponent from "segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/header-menu-component";
import HamburgerMenuComponent from "components/core/top-bar-new/hamburger-menu/hamburger-menu-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getClusterDesktopLogo, getMiniSiteLogo } from "client/services/cluster-config-service/cluster-config-service";
import Banner from "segments/desktop/core-components/banner/banner";
import { NEW_SOFT_SIGNUP_LINK } from "constants/links";
import { withAbTests } from "/contexts/ab-tests-context";
import { HEADER_POPUP_DATA } from "constants/header-popup";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { StyledBaseHeaderMobileComponent } from "./base-header-mobile-component.scss";
import constants from "../constants";
import SecondaryHeaderMobileComponent from "../secondary-header/secondary-header-mobile/secondary-header-mobile-component";
import SubmenuHeaderComponent from "./submenu-header/submenu-header-component";
import { AI_MENU_ID, SOLUTIONS_MENU_ID, RESOURCES_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
const SCROLL_MODE_THRESHOLD = 2; // The amount of pixels from the top that will trigger the scrolled mode of the navbar
const MONDAY_WHITE_LOGO = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/img/monday_logo_white.png";
const SUBMENU_TITLE_KEYS = {
    [AI_MENU_ID]: "header.aiPlatform",
    [SOLUTIONS_MENU_ID]: "header.solutions",
    [RESOURCES_MENU_ID]: "header.resources"
};
class BaseHeaderMobileComponent extends PureComponent {
    componentDidMount() {
        window.addEventListener("scroll", this.scrollListener);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.scrollListener);
    }
    render() {
        const { showMenu, isSecondaryMenuNeeded, translate, shouldUseDynamicColor } = this.props;
        const { isMenuOpen, activeSubmenuId } = this.state;
        const displayedSubmenuId = activeSubmenuId || this._lastActiveSubmenuId;
        const logo = this.getMondayLogo();
        const displayClusterLogo = this.shouldDisplayClusterizedLogo();
        const renderStickySignup = this.shouldShowStickySignup();
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(StyledBaseHeaderMobileComponent, {
                    className: classnames("base-header-mobile-component", {
                        "secondary-header": isSecondaryMenuNeeded,
                        "with-cluster-logo": displayClusterLogo,
                        "sticky-signup": renderStickySignup
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(BasicHeaderComponent, {
                            ref: (element)=>this._basicHeader = element,
                            showMenu: showMenu,
                            imageHref: logo.url,
                            imageSrc: logo.src,
                            imageAlt: logo.alt,
                            isMobile: true,
                            isSecondaryMenuNeeded: isSecondaryMenuNeeded,
                            className: "mobile-basic-header",
                            isMenuOpen: isMenuOpen,
                            shouldUseDynamicColor: shouldUseDynamicColor,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "mobile-menu-right-section",
                                children: [
                                    renderStickySignup && this.renderSignup(),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mobile-header-content",
                                        "aria-label": translate("header.mainMenu"),
                                        role: "navigation",
                                        children: /*#__PURE__*/ _jsx(HamburgerMenuComponent, {
                                            changeStateCallback: this.toogleOpenMenu,
                                            isOpen: isMenuOpen
                                        })
                                    })
                                ]
                            })
                        }),
                        isMenuOpen && displayedSubmenuId && /*#__PURE__*/ _jsx(SubmenuHeaderComponent, {
                            isVisible: !!activeSubmenuId,
                            onBack: ()=>this.setActiveSubmenuId(null),
                            onClose: ()=>this.toogleOpenMenu(false),
                            title: translate(SUBMENU_TITLE_KEYS[displayedSubmenuId])
                        }),
                        isSecondaryMenuNeeded && /*#__PURE__*/ _jsx(SecondaryHeaderMobileComponent, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("header-menu-component-wrapper", {
                                "is-open": isMenuOpen
                            }),
                            children: /*#__PURE__*/ _jsx(HeaderMenuComponent, {
                                isMinisitePage: isSecondaryMenuNeeded,
                                isMenuOpen: isMenuOpen,
                                activeSubmenuId: activeSubmenuId,
                                onSubmenuChange: this.setActiveSubmenuId
                            })
                        })
                    ]
                }),
                this.renderLogoPopupIfNeeded()
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "isScrolled", ()=>{
            var _window, _document_documentElement, _document;
            return (((_window = window) === null || _window === void 0 ? void 0 : _window.pageYOffset) || ((_document = document) === null || _document === void 0 ? void 0 : (_document_documentElement = _document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.scrollTop)) >= SCROLL_MODE_THRESHOLD;
        });
        _define_property(this, "scrollListener", (event)=>{
            const { isScrolled } = this.state;
            const isInScrollMode = this.isScrolled();
            if (isInScrollMode !== isScrolled) {
                this.setState({
                    isScrolled: isInScrollMode
                });
            }
        });
        _define_property(this, "shouldDisplayClusterizedLogo", ()=>{
            const { pageClusterConfig, isSecondaryMenuNeeded, pageClusterId, pageSubClusterId, useProductMiniSiteConfig } = this.props;
            if (pageClusterConfig && (isSecondaryMenuNeeded || pageClusterId || pageSubClusterId)) {
                return !!getMiniSiteLogo(pageClusterConfig, {
                    useProductMiniSiteConfig
                });
            }
            return false;
        });
        _define_property(this, "getMondayLogo", ()=>{
            const { pageClusterConfig, useProductMiniSiteConfig } = this.props;
            const { logoHref, logoSrc } = this.props;
            if (this.shouldDisplayClusterizedLogo()) {
                var _pageClusterConfig_mini_site_logo, _pageClusterConfig_mini_site;
                const useDesktopLogoInMobile = (pageClusterConfig === null || pageClusterConfig === void 0 ? void 0 : (_pageClusterConfig_mini_site = pageClusterConfig.mini_site) === null || _pageClusterConfig_mini_site === void 0 ? void 0 : (_pageClusterConfig_mini_site_logo = _pageClusterConfig_mini_site.logo) === null || _pageClusterConfig_mini_site_logo === void 0 ? void 0 : _pageClusterConfig_mini_site_logo.useDesktopLogoInMobile) === "true";
                return useDesktopLogoInMobile ? getClusterDesktopLogo(pageClusterConfig, {
                    useProductMiniSiteConfig
                }) : getMiniSiteLogo(pageClusterConfig, {
                    useProductMiniSiteConfig
                });
            }
            return {
                src: logoSrc,
                url: logoHref
            };
        });
        _define_property(this, "setActiveSubmenuId", (id)=>{
            if (id) {
                this._lastActiveSubmenuId = id;
            }
            this.setState({
                activeSubmenuId: id
            });
        });
        _define_property(this, "enterMobileMenuAbTest", ()=>{
            // leaving for future menu ab tests
            const { abTests } = this.props;
        });
        _define_property(this, "toogleOpenMenu", (isMenuOpen)=>{
            if (isMenuOpen) {
                var _document;
                this._basicHeader.forceShadow();
                this.enterMobileMenuAbTest();
                // Remove focus when opening the menu
                // Should close all native autocompletes
                if ((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                this._basicHeader.unforceShadow();
            }
            const newState = {
                isMenuOpen
            };
            if (!isMenuOpen) {
                // Close submenu when main menu is closed
                newState.activeSubmenuId = null;
                this._lastActiveSubmenuId = null;
            }
            this.setState(newState);
        });
        _define_property(this, "renderLogoPopupIfNeeded", ()=>{
            const { translate, logoPopup, localeId } = this.props;
            const popupData = HEADER_POPUP_DATA[logoPopup];
            if (!popupData) return null;
            const key = popupData.mobileTextKey || popupData.textKey;
            const imageSource = popupData.mobileImageSrc || popupData.gifSrc;
            const bannerText = translate(key).replace("<br>", " "); // desktop popup text can have specific breaks
            return /*#__PURE__*/ _jsx(Banner, {
                withSignupButton: false,
                bannerText: bannerText,
                bannerLinkData: {
                    text: translate(popupData.ctaKey),
                    src: popupData.getLink(localeId)
                },
                theme: popupData.bannerTheme,
                bannerleftImage: imageSource
            });
        });
        _define_property(this, "renderSignup", ()=>{
            const { translate } = this.props;
            return /*#__PURE__*/ _jsx("div", {
                className: "sticky-signup-wrapper",
                children: /*#__PURE__*/ _jsx(RegularButton, {
                    buttonText: translate("signup.cta"),
                    url: NEW_SOFT_SIGNUP_LINK,
                    color: WORK_OS_IRIS_COLOR_NAME
                })
            });
        });
        _define_property(this, "shouldShowStickySignup", ()=>{
            const { mobileStickySignup } = this.props;
            if (this.shouldDisplayClusterizedLogo()) return false;
            return mobileStickySignup || false;
        });
        this.state = {
            isMenuOpen: false,
            isScrolled: false,
            activeSubmenuId: null
        };
        // Similar logic to lastActiveSubmenuIdRef in HeaderMenuComponent:
        // Store last active submenu id to keep the active submenu showing when closing animation is running
        this._lastActiveSubmenuId = null;
    }
}
export default withGenericConfig(withAbTests(BaseHeaderMobileComponent));
